import { TextField } from "../../../../utils/form";

const DocumentNumber = ({ form: { control } }) => 
  <TextField control={control} name="documentNumber" label="DNI" variant="outlined" required helperText="Sin puntos ni comas" />

export default DocumentNumber;